import reactReplacePlaceholder from 'react-replace-placeholder';

import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';

import { withI18n } from '../../../contexts/i18n';

import type { TranslationKey } from '@shared/constants/translations';
import type { I18nService } from '@shared/types/i18n';

type Props = {
  i18n: I18nService;
  data?: any;
  label: TranslationKey;
  startTag?: string;
  endTag?: string;
  strong?: boolean;
};

const FormattedMessage = ({
  data = {},
  endTag = '}',
  i18n,
  label,
  startTag = '{',
  strong,
}: Props) => {
  const replacements = strong
    ? {
        strong: {
          pair: '/strong',
          // eslint-disable-next-line react/no-unstable-nested-components
          format: (text: string) => (
            <BpkText textStyle={TEXT_STYLES.label1}>{text}</BpkText>
          ),
        },
        ...data,
      }
    : data;

  if (Object.values(replacements || {}).some((v) => typeof v === 'object')) {
    return reactReplacePlaceholder(
      i18n.translations()[label],
      replacements,
      startTag,
      endTag,
    );
  }

  return <>{i18n.translate(label, replacements, startTag, endTag)}</>;
};

export default withI18n(FormattedMessage);
